import { Helmet } from "react-helmet";
import wirenboard from '../../assets/images/partner-wirenboard.webp';
import dallmeier from '../../assets/images/partner-dallmeier.webp';
import './partners.scss';
import { useTranslation } from "react-i18next";

const Partners: React.FC = () => {
    const { t } = useTranslation();
    return (
        <section className="partners">

            <Helmet>
                <title>Партнеры - Dallmeier и WirenBoard</title>
                <meta name="description" content="Наши партнеры: Dallmeier - производитель камер и систем видеонаблюдения, Panomera, WirenBoard - российская компания по разработке электроники для автоматизации." />
                <meta name="keywords" content="Panomera, Dallmeier, Обслуживание, партнеры, видеонаблюдение, системы безопасности, автоматизация, WirenBoard" />
            </Helmet>
            <h1 className='partners__header'>{t("partners.title")}</h1>
            <div className="partner">
                <div className="partner__text">
                    <p>{t("partners.partners_list.partner1.description")}</p>
                </div>
                <div className="partner__link">
                    <a href='https://wirenboard.com/ru/' className='partner__link-a'><img src={wirenboard} alt="logotype wirenboard" className='partner__link-img' /></a>
                    <a href="https://wirenboard.com"><p className='partner__link-a'>https://wirenboard.com</p></a>
                    <a href="tel:+74951506619"><p className='partner__link-a'>+7 (495) 150-66-19</p></a>
                </div>
            </div>
            <div className="partner">
                <div className="partner__text">
                    <p>{t("partners.partners_list.partner2.description")}.</p>
                </div>
                <div className="partner__link">
                    <a href='https://www.dallmeier.com' className='partner__link-a'><img src={dallmeier} alt="logotype wirenboard" className='partner__link-img' /></a>
                    <a href="https://www.dallmeier.com"><p className='partner__link-a'>https://www.dallmeier.com</p></a>
                </div>
            </div>
        </section>
    )
}
export default Partners;